import * as React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import RenderMark from '../../shared/components/RenderMark';
import t from '../../shared/translations';
import { Dispatch, openModal } from '../state';
import { ICurrentPerson } from './Profile';
import { Button } from './stylins';

interface IProps {
    person: ICurrentPerson;
}

const Section = styled.section`
    display: flex;
    flex-direction: column;
    text-align: center;
    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: space-around;
        flex-wrap: wrap;
        > * {
            margin: 0.5rem;
        }
    }
`;

const Pic = styled.img`
    width: 150px;
    height: 160px;
    object-fit: cover;
    margin-bottom: 1rem;
`;

const Avatar = styled.img`
    width: 130px;
    height: 160px;
    object-fit: scale-down;
    margin-bottom: 1rem;
`;

const Note = styled(RenderMark)`
    width: 100%;
    margin: 0 0 1.25rem 0;
`;

function PictureSection({ person }: IProps): JSX.Element {
    const dispatch = useDispatch<Dispatch>();

    const openPicture = () => {
        dispatch(openModal('Profile/ChangeProfilePicture'));
    };

    const openAvatar = () => {
        dispatch(openModal('Profile/ChangeAvatar'));
    };

    return <Section>
        <div>
            <Pic src={person.profilePicSrc || '/static/images/profile-silouette.png'} /><br />
            <Button onClick={openPicture}>
                {t('player.profile.button-change-profile-picture')}
            </Button>
        </div>
        <div>
            <Avatar src={person.avatarUrl} alt='avatar' /><br />
            <Button onClick={openAvatar}>
                {t('player.profile.button-change-avatar')}
            </Button>
        </div>
        <Note content={person.noteForPlayer} />
    </Section>;
}

export default PictureSection;
